/**
 * Get n second(s) as milliseconds
 *
 * @param {number} [n=1] The number of seconds to convert
 * @return {number}
 */
export const seconds = (n = 1) => n * 1000;
export { seconds as second };

/**
 * Get n minute(s) as milliseconds
 *
 * @param {number} [n=1] The number of minutes to convert
 * @return {number}
 */
export const minutes = (n = 1) => seconds(n) * 60;
export { minutes as minute };

/**
 * Get n hour(s) as milliseconds
 *
 * @param {number} [n=1] The number of hours to convert
 * @return {number}
 */
export const hours = (n = 1) => minutes(n) * 60;
export { hours as hour };

/**
 * Get n days(s) as milliseconds
 *
 * @param {number} [n=1] The number of days to convert
 * @return {number}
 */
export const days = (n = 1) => hours(n) * 24;
export { days as day };
